import { getCredits } from "../../redux/features/customer/customerActions";

/**
 * Refetches wallet balance into Redux (`state.customer.credits`) so the navbar stays in sync
 * after a transaction that changes credits on the server.
 */
export function refreshCustomerCredits(dispatch) {
  try {
    const token = localStorage.getItem("token");
    if (!token) return;
    JSON.parse(token);
  } catch {
    return;
  }
  void dispatch(getCredits({}));
}
